module.exports = __webpack_public_path__ + "static/media/sf-test-17.301dd386.mp3";